module.exports = __webpack_public_path__ + "img/ball_6_transparent.99084cab.png";